<template>
  <main class="main-home flex min-h-[calc(100vh-88px)] items-center justify-center px-4 py-10">
    <section class="w-full max-w-3xl">
      <div class="grid grid-cols-1 gap-4 sm:grid-cols-2">
        <router-link
          v-for="item in primaryMenus"
          :key="item.name"
          :to="{ name: item.name }"
          class="primary-card"
        >
          <span class="text-6xl leading-none sm:text-7xl" aria-hidden="true">{{ item.emoji }}</span>
          <span class="mt-5 text-2xl font-black text-white sm:text-3xl">{{ item.label }}</span>
        </router-link>
      </div>
      <div class="mx-auto mt-5 grid max-w-lg grid-cols-2 gap-3">
        <router-link
          v-for="item in secondaryMenus"
          :key="item.name"
          :to="{ name: item.name }"
          class="secondary-card"
        >
          <span v-if="item.icon === 'rubber-ball'" class="rubber-ball" aria-hidden="true">
            <svg viewBox="0 0 64 64">
              <defs>
                <radialGradient id="rubber-ball-fill" cx="34%" cy="30%" r="72%">
                  <stop offset="0%" stop-color="#ffb4b4" />
                  <stop offset="38%" stop-color="#ef3d3d" />
                  <stop offset="100%" stop-color="#8d1212" />
                </radialGradient>
              </defs>
              <circle cx="32" cy="32" r="28" fill="url(#rubber-ball-fill)" />
              <ellipse cx="24" cy="20" rx="11" ry="7" fill="rgba(255,255,255,0.62)" />
            </svg>
          </span>
          <span v-else class="text-2xl leading-none" aria-hidden="true">{{ item.emoji }}</span>
          <span class="text-sm font-black text-slate-100 sm:text-base">{{ item.label }}</span>
        </router-link>
      </div>
    </section>
  </main>
</template>

<script>
export default {
  name: 'MainView',
  data() {
    return {
      primaryMenus: [
        { name: 'lotto', label: '로또번호추천', emoji: '🎱' },
        { name: 'fortuneCookie', label: '포춘쿠키', emoji: '🍀' },
      ],
      secondaryMenus: [
        { name: 'tangtangball', label: '탱탱볼', icon: 'rubber-ball' },
        { name: 'boardList', label: '게시판', emoji: '📋' },
      ],
    };
  },
};
</script>

<style scoped>
.main-home {
  background:
    radial-gradient(circle at 18% 12%, rgba(30, 200, 255, 0.18), transparent 28rem),
    radial-gradient(circle at 88% 80%, rgba(255, 92, 138, 0.12), transparent 26rem),
    linear-gradient(160deg, #080f1a 0%, #101a2a 52%, #0d2236 100%);
}

.primary-card,
.secondary-card {
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid rgba(255, 255, 255, 0.1);
  background: rgba(17, 26, 39, 0.88);
  box-shadow: 0 18px 50px rgba(0, 0, 0, 0.28);
  transition:
    transform 160ms ease,
    border-color 160ms ease,
    background-color 160ms ease;
}

.primary-card {
  min-height: 240px;
  flex-direction: column;
  border-radius: 32px;
  padding: 2rem 1.5rem;
}

.secondary-card {
  min-height: 72px;
  gap: 0.6rem;
  border-radius: 18px;
  padding: 0.9rem 1rem;
}

.rubber-ball svg {
  width: 100%;
  height: 100%;
}

.rubber-ball {
  display: inline-flex;
  width: 1.7rem;
  height: 1.7rem;
  filter: drop-shadow(0 2px 2px rgba(0, 0, 0, 0.35));
}

.primary-card:hover,
.secondary-card:hover {
  transform: translateY(-3px);
  border-color: rgba(30, 200, 255, 0.45);
  background: rgba(22, 40, 61, 0.95);
}
</style>
